export const API = {
    REQUEST_START: 'API_REQUEST_START',
    REQUEST_END: 'API_REQUEST_END',
    ADD_ERROR: 'API_ADD_ERROR',
    RESET_ERROR: 'API_RESET_ERROR',
};
